export default [
  {
    iconClassName: 'icon-quanbu-33x',
    keyword: ['全部'],
  },
  {
    iconClassName: 'icon-quanxian-23x',
    keyword: ['权限'],
  },
  {
    iconClassName: 'icon-jiage-33x',
    keyword: ['价格', '现金'],
  },
  {
    iconClassName: 'icon-lujing3x',
    keyword: ['活动'],
  },
  {
    iconClassName: 'icon-shuju-33x',
    keyword: ['数据', '报表', '产品'],
  },
  {
    iconClassName: 'icon-tuituibang3x',
    keyword: ['推推棒'],
  },
  {
    iconClassName: 'icon-xingzhuang3x',
    keyword: ['商品'],
  },
  {
    iconClassName: 'icon-R3x',
    keyword: ['锐锢'],
  },
  {
    iconClassName: 'icon-shouji3x',
    keyword: ['专题'],
  },
  {
    iconClassName: 'icon-3603x',
    keyword: ['360'],
  },
  {
    iconClassName: 'icon-renyuan3x',
    keyword: ['个人', '用户'],
  },
  {
    iconClassName: 'icon-baojing3x',
    keyword: ['110'],
  },
  {
    iconClassName: 'icon-Fill13x',
    keyword: ['供应'],
  },
  {
    iconClassName: 'icon-zidian3x',
    keyword: ['分词', '管理'],
  },
  {
    iconClassName: 'icon-vip3x',
    keyword: ['客户'],
  },
  {
    iconClassName: 'icon-bianzu3x',
    keyword: ['入驻宝'],
  },
  {
    iconClassName: 'icon-weixin',
    keyword: ['微信'],
  },
]
